import React from "react";
import { ShieldCheck, FileText, Stamp, Users } from "lucide-react";
import { useInView } from "@/hooks/useReveal";

const PROMISES = [
  {
    n: "01",
    icon: ShieldCheck,
    title: "Ingyenes felmérés",
    body: "Felhívjuk, és a helyszíni felmérés mindig térítésmentes, kötelezettség nélküli.",
  },
  {
    n: "02",
    icon: FileText,
    title: "Tételes ajánlat",
    body: "Átlátható, tételes árajánlatot adunk, hogy pontosan lássa, miért fizet.",
  },
  {
    n: "03",
    icon: Stamp,
    title: "Írásos garancia",
    body: "Minden munkára írásos garanciát vállalunk, amit a befejezéskor átadunk.",
  },
  {
    n: "04",
    icon: Users,
    title: "Nincs alvállalkozó",
    body: "Saját, állandó ácsbrigád dolgozik a tetőn — idegen napszámos nem lép rá.",
  },
];

export default function Promises() {
  const [ref, inView] = useInView();
  return (
    <section
      id="garanciak"
      ref={ref}
      data-testid="promises-section"
      className="section"
      style={{ background: "var(--ink-2)", borderTop: "1px solid var(--line)", borderBottom: "1px solid var(--line)" }}
    >
      <div className="site-container">
        <div
          className="prom-head"
          style={{ display: "grid", gridTemplateColumns: "1fr", gap: 28, marginBottom: 56 }}
        >
          <style>{`
            @media (min-width: 900px) {
              .prom-head { grid-template-columns: 1fr 1fr !important; gap: 80px !important; align-items: end !important; }
            }
          `}</style>
          <div className={`reveal ${inView ? "in-view" : ""}`}>
            <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 20 }}>
              <span style={{ height: 1, background: "var(--gold)", width: 32 }} />
              <span className="eyebrow">03 — Garanciák</span>
            </div>
            <h2 className="h2" style={{ margin: 0 }}>
              Négy dolog, amit <span style={{ color: "var(--gold)" }}>írásban is vállalok.</span>
            </h2>
          </div>
          <p className={`lead reveal reveal-1 ${inView ? "in-view" : ""}`} style={{ margin: 0, maxWidth: 460 }}>
            Nem ígérgetés, nem marketing-szöveg. Az alábbi négy elv minden munkámnál érvényes — és aláírom is, hogy az legyen.
          </p>
        </div>

        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
          gap: 0,
          borderTop: "1px solid var(--line)",
        }}>
          <style>{`
            @media (min-width: 900px) {
              [data-testid="promises-section"] .prom-card { border-right: 1px solid var(--line); }
              [data-testid="promises-section"] .prom-card:last-child { border-right: none; }
            }
            [data-testid="promises-section"] .prom-card { transition: background 240ms ease; }
            [data-testid="promises-section"] .prom-card:hover { background: var(--ink-3); }
            [data-testid="promises-section"] .prom-card:hover .prom-icon { color: var(--gold); }
            [data-testid="promises-section"] .prom-card:hover .prom-num { color: var(--gold); }
          `}</style>
          {PROMISES.map((p, i) => {
            const Icon = p.icon;
            return (
              <div
                key={p.n}
                data-testid={`promise-${i}`}
                className={`prom-card reveal reveal-${Math.min(i + 1, 4)} ${inView ? "in-view" : ""}`}
                style={{
                  padding: "36px 28px",
                  borderBottom: "1px solid var(--line)",
                  display: "flex", flexDirection: "column", gap: 18,
                  minHeight: 240,
                }}
              >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span className="prom-num font-display" style={{
                    fontSize: 13, color: "var(--text-dim)", letterSpacing: "0.06em",
                    transition: "color 240ms ease",
                  }}>
                    {p.n}
                  </span>
                  <Icon className="prom-icon" size={22} strokeWidth={1.4} color="var(--text)" style={{ transition: "color 240ms ease" }} />
                </div>
                <h3 className="h3" style={{ margin: 0, fontSize: 19 }}>
                  {p.title}
                </h3>
                <p className="body" style={{ margin: 0, marginTop: "auto" }}>
                  {p.body}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
